module.exports = __webpack_public_path__ + "img/corriere-della-sera.4375a4a5.png";